import React, { useGlobal } from 'reactn';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import CreditCardIcon from '@material-ui/icons/CreditCard';
import AccountBalanceIcon from '@material-ui/icons/AccountBalance';
import AssessmentIcon from '@material-ui/icons/Assessment';
import { useLogger } from '../logger';
import { useHistory } from "react-router-dom";
import { Roles } from '../models';
import CompanyIcon from '@material-ui/icons/Business';
import UserIcon from '@material-ui/icons/Person';
import DownloadIcon from '@material-ui/icons/GetApp';
import ImportIcon from '@material-ui/icons/ImportExport';
import AgencyIcon from '@material-ui/icons/HomeWork';
import NewsIcon from '@material-ui/icons/Announcement';
import { Divider, Fab, Grid, IconButton, List, ListItem, ListItemIcon, ListItemText, Theme, useTheme, createStyles, makeStyles, SwipeableDrawer, useMediaQuery } from '@material-ui/core';
import { IGlobalState } from '../states/GlobalState';
import { drawerWidth, breakpoint } from '../types/constants';

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
    //Drawer
    drawer: {
      width: drawerWidth,
      flexShrink: 0,
    },
    drawerPaper: {
      width: drawerWidth,
    },
    drawerHeader: {
      display: 'flex',
      alignItems: 'center',
      padding: '0 8px',
      ...theme.mixins.toolbar,
      justifyContent: 'flex-end',
      minHeight: '60px!important'
    },
    nav: {
      flex: 1,
      '&:hover': {
          overflow: 'auto'
      }
    },
    content: {
      flexGrow: 1,
      padding: theme.spacing(1),
      transition: theme.transitions.create('margin', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
      marginLeft: -drawerWidth,
    },
    contentShift: {
      transition: theme.transitions.create('margin', {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
      marginLeft: 0,
    },
    buttonIcon: {
      margin: "1rem",
      cursor: "pointer"
    }

  }),
);

export type DrawerProps = {
    apptabs: String[] | undefined;
    handleChangeApplicazione: any;
    handleChange: any;
}

export default function Drawer(props: DrawerProps) {
    const theme = useTheme();
    const classes = useStyles();
    const [identity,] = useGlobal<IGlobalState, 'identity'>('identity');
    const [, setApplication] = useGlobal<IGlobalState, 'application'>('application');
    const [drawerIndex, setDrawerIndex] = useGlobal<IGlobalState, 'drawerIndex'>('drawerIndex');
    const [auth] = useGlobal<IGlobalState, 'auth'>('auth');
    const mobile = useMediaQuery(theme.breakpoints.down(breakpoint));
    const history = useHistory();
    const logger = useLogger({key: 'identity'});
    const [drawerIsOpen, setDrawerIsOpen] = useGlobal<IGlobalState, 'drawerIsOpen'>('drawerIsOpen');

    function handleDrawerClose() {
        // setOpen(false);
        setDrawerIsOpen(false);
        // props.leftMenuOpenClosed(false);
    }
     
    const getNomeMenuForfetari = (): string => {
      let nome = 'Forfetari';
      if (identity?.Company?.ForfetariMenuName) {
        nome = identity?.Company?.ForfetariMenuName;
      }
      return nome;
    }
    
    const getNomeMenuBudget = (): string => {
      let nome = 'Budget4u';
      if (identity?.Company?.BudgetMenuName) {
        nome = identity?.Company?.BudgetMenuName;
      }
      return nome;
    }
    
    function handleListItemAdminClick(event: React.MouseEvent<HTMLDivElement, MouseEvent>, index: number) {
        setDrawerIndex(index);
    
        switch (index) {
          case 1:
            if (identity && identity.ApplicationForfetari === true) {
              if (props.handleChangeApplicazione) {
                props.handleChangeApplicazione(index);
              } 
              setApplication(index); 
              history.push("/iforf");
            } else {
              logger.error('Non hai i diritti per andare sull\'applicazione');
            }
            break;
            
          case 2:
            if (identity && identity.ApplicationConvenienza === true) {
              // props.handleChangeApplicazione(index); 
              // setApplication(Applicazioni.ConvSrl); 
              history.push("/convsrl");
            } else {
              logger.error('Non hai i diritti per andare sull\'applicazione');
            }
            break;
    
          case 3:
            if (identity && identity.ApplicationBudget === true) {
              if (props.handleChangeApplicazione) {
                props.handleChangeApplicazione(index);
              }
              setApplication(index); 
              // props.handleChange(index); 
              history.push("/budget");
            } else {
              logger.error('Non hai i diritti per andare sull\'applicazione');
            }
            break;
              
          case 5:
            history.push("/company");
            break;
          
          case 6:          
            history.push("/agency");
            break;
          
          case 7:
        
            history.push("/principal");
            // history.push("/pageusers");
            break;
          
          case 8:      
            history.push("/whatsnew");
            break;
          
          case 9:      
            // clearIdentityFromStorage();
            history.push("/importtelematico");
            break;
          
          case 10:      
            history.push("/report");
            break;
          
          default:
            break;
        }
    }
    
    return (
        <>
        <SwipeableDrawer
            id='drawer'
            className={classes.drawer}
            variant={!mobile ? 'persistent' : 'temporary'}            
            anchor="left"
            open={drawerIsOpen}
            classes={{paper: classes.drawerPaper}}
            onOpen={() => setDrawerIsOpen(true)}
            onClose={() => setDrawerIsOpen(false)}
        >
            <div className={classes.drawerHeader}>
                <IconButton onClick={handleDrawerClose}>
                    {theme.direction === 'ltr' ? <ChevronLeftIcon /> : <ChevronRightIcon />}
                </IconButton>
            </div>
            {/*props.apptabs && props.applicazione <= Applicazioni.Budget4u ? (
            <>
            <Divider />
              <List>
                  {props.apptabs!.map((text, index) => (
                  <ListItem key={index} button onClick={event => handleListItemClick(event, index)}>
                      <ListItemIcon>{index === 0 ? <InboxIcon /> : index === (props.apptabs!.length - 1) ? <CompareIcon /> : <OutputIcon />}</ListItemIcon>
                      <ListItemText primary={text} />
                  </ListItem>
                  ))}
              </List>
            </>
            ) : null
            */}
            <Divider />
            <List>
                {identity && identity.ApplicationForfetari === true /*&& props.applicazione === Applicazioni.iForfettari*/ ? (
                <ListItem button selected={drawerIndex === 1} onClick={(event) => handleListItemAdminClick(event, 1)}>
                <ListItemIcon>
                    <AccountBalanceIcon /> 
                </ListItemIcon>
                {/* <ListItemText primary={window.location.host.includes("wki-") ? "Convenienza forfetario" : "Forfetari"} /> */}
                <ListItemText primary={getNomeMenuForfetari()} />
                </ListItem>
                )
                : null
                }
                {identity && identity.ApplicationConvenienza === true /*&& props.applicazione === Applicazioni.ConvSrl*/ ? (
                <ListItem button selected={drawerIndex === 2} onClick={(event) => handleListItemAdminClick(event, 2)}>
                <ListItemIcon>
                    <AssessmentIcon /> 
                </ListItemIcon>
                <ListItemText primary="Convenienza Srl" />
                </ListItem>
                )
                : null
                }
                {identity && identity.ApplicationBudget === true /*&& props.applicazione === Applicazioni.Budget4u*/ ? (
                <ListItem button selected={drawerIndex === 3} onClick={(event) => handleListItemAdminClick(event, 3)}>
                <ListItemIcon>
                    <CreditCardIcon /> 
                </ListItemIcon>
                {/* <ListItemText primary={window.location.host.includes("wki-") ? "Simulazione carico fiscale" : "Budget4u"} /> */}
                <ListItemText primary={getNomeMenuBudget()} />
                </ListItem>
                )
                : null
                }
                {identity && identity.Role === Roles.SUPERADMIN ? (
                <ListItem button selected={drawerIndex === 5} onClick={(event) => handleListItemAdminClick(event, 5)}>
                <ListItemIcon>
                    <CompanyIcon /> 
                </ListItemIcon>
                <ListItemText primary="Company" />
                </ListItem>
                )
                : null
                }
                {identity && (identity.Role === Roles.SUPERADMIN || identity.Role === Roles.ADMIN)  ? (
                <ListItem button selected={drawerIndex === 6} onClick={(event) => handleListItemAdminClick(event, 6)}>
                <ListItemIcon>
                    <AgencyIcon /> 
                </ListItemIcon>
                <ListItemText primary="Studi" />
                </ListItem>
                )
                : null
                }
                {identity && (identity.Role === Roles.SUPERADMIN || identity.Role === Roles.ADMIN || identity.Role === Roles.MANAGER) && identity.UserCreation === true ? 
                <ListItem button selected={drawerIndex === 7} onClick={(event) => handleListItemAdminClick(event, 7)}>
                <ListItemIcon>
                    <UserIcon /> 
                </ListItemIcon>
                <ListItemText primary="Utenti" />
                </ListItem>
                : null
                }
                {identity && identity.Role === Roles.SUPERADMIN ? (
                <ListItem button selected={drawerIndex === 8} onClick={(event) => handleListItemAdminClick(event, 8)}>
                <ListItemIcon>
                    <NewsIcon /> 
                </ListItemIcon>
                <ListItemText primary="What's New" />
                </ListItem>
                )
                : null
                }
                {identity && (identity.Role === Roles.SUPERADMIN || identity.Company?.ImportEnabled === true) ? (
                <ListItem button selected={drawerIndex === 9} onClick={(event) => handleListItemAdminClick(event, 9)}>
                <ListItemIcon>
                    <ImportIcon /> 
                </ListItemIcon>
                <ListItemText primary="Import telematico" />
                </ListItem>
                )
                : null
                }
                {identity && (identity.Role === Roles.SUPERADMIN || identity.ReportEnabled === true) ? 
                <ListItem button selected={drawerIndex === 10} onClick={(event) => handleListItemAdminClick(event, 10)}>
                <ListItemIcon>
                    <DownloadIcon /> 
                </ListItemIcon>
                <ListItemText primary="Report" />
                </ListItem>
                : null
                }
           </List>
        </SwipeableDrawer>
        </>
    );

}